module.exports = __webpack_public_path__ + "static/img/sou-n@2x.f0babcf8.png";